import { v4 } from "uuid";

import router from "@/router";
/**
 * vue 返回上一页
 */
export const backUrl = () => {
  router.back();
};
// 下载文件
export function exportFile(data: any, fileName: string) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.href = url;
  a.download = fileName;
  a.click();
  document.body.removeChild(a);
}

// 获取文件格式(demo.jpg -> jpg)
export function getFileExtension(filename: string) {
  return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
}

// 生成uuid
export function createUuid() {
  return v4();
}

// 二进制颜色转化为rgb
export function binaryColorToRgb(binaryColor: any) {
  let binaryString = binaryColor.toString();
  let r = binaryString.substr(6, 2) / 255;
  let g = binaryString.substr(4, 2) / 255;
  let b = binaryString.substr(2, 2) / 255;
  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

export function getFileNameWithoutExtension(url: string) {
  // 使用URL对象解析URL
  const urlObj = new URL(url);
  // 使用split('/')分割URL，获取最后一个部分作为文件名
  const fileName = urlObj.pathname.split("/").pop();
  // 使用split('.')分割文件名，获取不带扩展名的部分
  const nameWithoutExtension = fileName!.split(".").slice(0, -1).join(".");
  return nameWithoutExtension;
}
